module.exports = __webpack_public_path__ + "img/11_wind.388fb82d.jpg";